export default __webpack_public_path__ + "static/media/opening-intercept.fa81161a.jpg";